<template>
  <Authenticated>
    <form v-on:submit.prevent="setup">
      <h1>Welcome to Beamy</h1>
      <h3>Company Setup</h3>
      <p>Configure your company settings to get started</p>
      <h2>Company name:</h2>
      <input name="company" v-model="company" placeholder="Company Name" autofocus autocomplete="company" />
      <div class="error" v-if="errors && errors.company">Company {{ errors.company.join(", ") }}</div>
      <div class="error" v-if="errors && errors.all">{{ errors.all }}</div>
      <button type="submit" value="Setup Company">Setup Company</button>
    </form>
  </Authenticated>
</template>

<script>
import Authenticated from "../_layouts/Authenticated.vue";
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";

export default {
  name: "Setup",
  components: { Authenticated },
  data() {
    return {
      errors: {},
      company: "",
    };
  },
  computed: {
    ...mapGetters({
      companyName: "companyName",
    }),
  },
  methods: {
    async setup() {
      try {
        // Add setup logic here
        // Redirect to next step
        this.$router.push("/setup/site");
      } catch (error) {
        this.errors = { all: "Setup failed: " + error.message };
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

form {
  display: flex;
  flex-direction: column;
  max-width: 400px;
  margin: 2rem auto;
  padding: 2rem;
  gap: 1rem;
}

input {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  padding: 0.75rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.error {
  color: red;
  font-size: 0.875rem;
}
</style>